import React from "react";
import CCOContainer from "../../fundamentals/CCOContainer";
import Grid from "@mui/material/Grid";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import {CmCollectionType, CmVideoType} from "../../types";
import C041Video from "../C041Video/C041Video";
import useWindowSize from "../../../utility/useWindowSize";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";

export interface Props {
    cmCollection: CmCollectionType
}

function C079ViewTypeVideo(props: Props) {
    const {greaterThanWindowMedium} = useWindowSize();
    const items = filterAvailableItems(props);
    return !items ? null : items.length === 1 || !greaterThanWindowMedium ?
        renderVideosWithoutWrapper(props.cmCollection, items) :
        renderVideosWithWrapper(props.cmCollection, items);
}

function filterAvailableItems(props: Props) {
    // Max 3 videos in a collection
    return props.cmCollection.items?.filter((_item, index) => index < 3);
}

function renderVideosWithoutWrapper(cmCollection: CmCollectionType, items: any[]) {
    return <React.Fragment>
        {renderTeaserTittle(cmCollection)}
        {items.map((item, index) => {
            const video = createVideo(item);
            return <C041Video key={index} video={video}/>;
        })}
    </React.Fragment>
}

function renderTeaserTittle(cmCollection: CmCollectionType) {
    if (cmCollection?.teaserTitle) {
        return <CCOComponentWrapper noBottomMargin={true}>
            <CCOHeadline metadataId={cmCollection.id} headline={cmCollection.teaserTitle}
                         type={"componenthead"}
                         propertyName='properties.teaserTitle'
                         subtextPropertyName='properties.teaserText'
                         subtext={cmCollection.teaserText?.textAsTree}/>
        </CCOComponentWrapper>
    }
    return null;
}

function createVideo(item: any) {
    const video = item as CmVideoType
    const url = video.dataUrl || video.selfUrl;
    video['dataUrl'] = url?.split(':CMVideo')[0];
    return video;
}

function renderVideosWithWrapper(cmCollection:CmCollectionType, items: any[]) {
    return (
        <CCOComponentWrapper>
            <CCOContainer width='large'>
                <Grid container spacing={6} sx={{
                    justifyContent: 'center'
                }}>
                    {renderTeaserTittle(cmCollection)}
                    {renderVideos(items)}
                </Grid>
            </CCOContainer>
        </CCOComponentWrapper>
    );
}

function renderVideos(items: any[]) {
    const gridItemSize = getGridItemSize(items?.length ?? 0);
    return items.map((item, index) => {
        const video = createVideo(item);
        return <Grid key={index} size={{sm: 12, md: gridItemSize}}>
            <C041Video video={video} noContainer/>
        </Grid>
    });
}

function getGridItemSize(itemCount: number) {
    switch (itemCount) {
        case 2:
            return 6;
        case 3:
            return 4;
    }
}

export default C079ViewTypeVideo